import React from 'react'
import PropTypes from 'prop-types'
import FJButton from "fj-components/FJButton";
import classNames from 'classnames'

import styles from './FJButtonSemicircle.module.less'

function FJButtonSemicircle(props) {

  let {
    icon,
    text,
    loading,
    className,
    onClick,
    danger,
    ghost,
    size,
    type,
    disabled,
    disabledClass,
    textClass,
    rightIcon,
		iconClass = ''
  } = props;

  let CN = classNames(styles.btn_radius, className, disabled ? disabledClass : '');
  return (
    <FJButton icon={icon}
              text={text}
              loading={loading}
              disabled={disabled}
              className={CN}
              danger={danger}
              ghost={ghost}
              size={size}
              type={type}
              onClick={onClick}
              textClass={textClass}
              rightIcon={rightIcon}
							iconClass={iconClass}
    />
  );
}

FJButtonSemicircle.propTypes = {
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  danger: PropTypes.bool,
  ghost: PropTypes.bool,
  text: PropTypes.string,
  shape: PropTypes.string,
  size: PropTypes.string,
  type: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func,
  block: PropTypes.bool,
};

export default FJButtonSemicircle;
